$(window).on("load",function(){
	// $("body").removeClass("preload");
});
$(function(){

	if($('.home').length) {
		//MVスライドショー
		// $('.slider_inner').each(function() {
		// 	var sliderWidth = $(this).width();
		// 	$(this).clone(true).insertBefore(this);
		// 	$(this).clone(true).insertAfter(this);
		// 	$('.slider').css('width', sliderWidth*3); // 親要素の横幅を子要素の３倍にする
		// });

		//MVスライドショー
		// $('.mv .Infiniteslide').infiniteslide({
		// 	speed: 80,
		// 	pauseonhover: false,
		// 	clone: 2,
		// });

		// setTimeout(function() {
	    //     new Vivus('sign_recruit', {
	    //         type: 'scenario-sync',
	    //         start: 'autostart',
	    //         duration: 40,
	    //         forceRender: false,
	    //         animTimingFunction: Vivus.EASE,
	    //     })
	    // }, 300);

	}

});